export default __webpack_public_path__ + "static/media/BigLineDown.e23464a7.mp3";